import React from 'react'
import Navbar from '../containers/Navbar/Navbar.container'
import Dashboard from '../containers/Dashboard/Dashboard.container'
import ManagementMenu from '../containers/ManagementMenu/ManagementMenu.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import { SendAlt } from '@carbon/icons-react'
import DashboardBody from '../containers/Dashboard/DashboardBody.container'
import TitleText from '../components/Layouts/Title'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import { useSession } from './../modules/hooks/security'
import routes from '../config/settings/routes'

const DashboardPage = () => {
  const { username } = useSession()
  return (
    <BrandLayout
      navbar={<Navbar managementMenu={<ManagementMenu current={routes.dashboard} />} />}
      header={
        <Heading 
          title='Inicio' 
          icon={<SendAlt size={50} />} 
          breadcrumbs={
            <Breadcrumb noTrailingSlash>
              <BreadcrumbItem>
                <a href="/#">Salar</a>
              </BreadcrumbItem>
              <BreadcrumbItem href="#" isCurrentPage>Inicio</BreadcrumbItem>
            </Breadcrumb>
          }
        />
      }
      childrenStyles={{ paddingLeft: 0 }}
    >
      <Dashboard>
        <TitleText
          prefix='SALAR SQM' 
          title={`Bienvenido, ${username}.`}
        />
        <DashboardBody />
      </Dashboard>
    </BrandLayout>
  )
}

export default DashboardPage

